/* Heriz Gallery custom scripts — Growth Pulse Media
   Product title: split trailing "230 × 160 cm" onto its own line.
   Title is CSS-hidden until processed (see .hg-title-ready rules);
   every code path below marks it ready so it can never stay hidden. */
document.addEventListener('DOMContentLoaded', function () {
  var h1 = document.querySelector('h1.product_title, product-info h1, h1.head');
  if (!h1) return;

  function ready() { h1.classList.add('hg-title-ready'); }

  if (!document.body.classList.contains('template-product')) { ready(); return; }
  if (h1.querySelector('.hg-title-size')) { ready(); return; }

  var m = h1.textContent.match(/^(.*?)(\d+(?:[.,]\d+)?\s*×\s*\d+(?:[.,]\d+)?\s*cm)\s*$/);
  if (m) {
    h1.textContent = m[1].trim();
    var s = document.createElement('span');
    s.className = 'hg-title-size';
    s.textContent = m[2].replace(/\s+/g, ' ').trim();
    h1.appendChild(s);
  }
  ready();
});

/* Heriz Gallery - Services page (#hg-services): accordion and active nav pill. GPM.
   The page editor strips <script> tags from page content, so this lives here. */
(function () {
  document.addEventListener('click', function (e) {
    var q = e.target.closest ? e.target.closest('#hg-services .sv-acc-q') : null;
    if (!q) return;
    var item = q.parentElement, a = item.querySelector('.sv-acc-a');
    var open = item.classList.toggle('is-open');
    q.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (a) a.style.maxHeight = open ? a.scrollHeight + 'px' : '0px';
  });
  function pills() {
    var root = document.getElementById('hg-services');
    if (!root || !('IntersectionObserver' in window)) return;
    root.querySelectorAll('.sv-acc-q').forEach(function (q) { q.setAttribute('aria-expanded', 'false'); });
    var links = root.querySelectorAll('.sv-nav .sv-pill');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        links.forEach(function (l) { l.classList.toggle('is-on', l.getAttribute('href') === '#' + en.target.id); });
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    root.querySelectorAll('.sv-sec[id]').forEach(function (s) { io.observe(s); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pills); else pills();
})();


/* Webkul auction: show amounts as "R 5,994.00", like the rest of the site (29 Sep 2026).
   Webkul prints "ZAR 5994". This rewrites only text nodes that contain "ZAR ". */
(function(){
  var RE=/ZAR\s*([0-9][0-9,]*(?:\.[0-9]+)?)/g;
  function fmt(a){var n=parseFloat(String(a).replace(/,/g,''));if(isNaN(n))return null;return 'R '+n.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});}
  function fixText(t){if(t.nodeValue&&t.nodeValue.indexOf('ZAR')>-1){var v=t.nodeValue.replace(RE,function(m,a){return fmt(a)||m;});if(v!==t.nodeValue)t.nodeValue=v;}}
  function fix(root){if(!root)return;if(root.nodeType===3){fixText(root);return;}if(root.nodeType!==1)return;var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null),n,l=[];while((n=w.nextNode()))l.push(n);l.forEach(fixText);}
  function start(){
    if(!document.querySelector('#wk-auction,.wk-category-auction,.wkcontainer')&&!/auction/.test(location.pathname))return;
    fix(document.body);
    new MutationObserver(function(ms){ms.forEach(function(m){if(m.type==='characterData')fixText(m.target);else m.addedNodes.forEach(fix);});}).observe(document.body,{childList:true,subtree:true,characterData:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();


/* My auction bids page: open on "Participated Auctions" and add theme touches (29 Sep 2026) */
(function(){
  if(location.pathname.indexOf('/tools/products-on-auction')!==0)return;
  var q=new URLSearchParams(location.search);
  if(q.get('callback')!=='getCustomerBiddingDetails')return;
  if(!q.get('f')&&(!q.get('t')||q.get('t')==='1')){q.set('t','1');q.set('f','1');location.replace(location.pathname+'?'+q.toString());return;}
  function run(){
    var p=document.getElementById('paTabs');if(!p)return false;if(p.dataset.hg)return true;p.dataset.hg='1';
    var h=p.querySelector('h1');
    if(h){h.textContent='My auction bids';h.insertAdjacentHTML('afterend','<p class="hg-bids-intro">Rugs you have bid on. The highest bid when the auction closes wins; winners pay within 48 hours.</p>');}
    if(!document.querySelector('.hg-bids-bc'))p.insertAdjacentHTML('beforebegin','<nav class="page-width breadcrumb fl f-wrap f-aic hg-bids-bc" aria-label="breadcrumbs"><a href="/">Home</a> <span class="bc-icon" aria-hidden="true">|</span><a href="/collections/auction">Auction</a> <span class="bc-icon" aria-hidden="true">|</span><span class="fw-500">My bids</span></nav>');
    p.querySelectorAll('.pa-table tr').forEach(function(tr){if(tr.children.length===1&&!tr.textContent.trim())tr.style.display='none';});p.querySelectorAll('td.td_highest_bidder').forEach(function(td){if(/^\s*you\s*$/i.test(td.textContent))td.classList.add('hg-you');});
    var tc=p.querySelector('.tab-content');if(tc&&!p.querySelector('.hg-bids-browse'))tc.insertAdjacentHTML('afterend','<div class="hg-bids-browse"><a href="/collections/auction">Browse all auction rugs</a></div>');
    return true;
  }
  var n=0;(function tick(){if(!run()&&n++<40)setTimeout(tick,250);})();
})();

/* HG: auction input placeholders ZAR -> R */
(function(){function fix(){document.querySelectorAll('#wk-auction input[placeholder]').forEach(function(i){if(/ZAR/.test(i.placeholder))i.placeholder=i.placeholder.replace(/ZAR/g,'R');});}if(!document.getElementById('wk-auction')&&!/products\//.test(location.pathname))return;var n=0,t=setInterval(function(){fix();if(++n>40)clearInterval(t);},250);})();
/* Webkul CSS (50px round buttons) leaks onto rugs not on auction: switch it off there (4 Oct 2026) */ (function(){function off(){if(document.documentElement.classList.contains('hg-auction-page'))return;document.querySelectorAll('link[href*=sp-auction]').forEach(function(l){l.media='not all';});}off();var mo=new MutationObserver(off);mo.observe(document.documentElement,{childList:true,subtree:true});setTimeout(function(){mo.disconnect();},30000);})();